import type { PrintablePlayerSortName } from '@sorare/core/src/contexts/config';

export const SORTS: PrintablePlayerSortName[] = [
  'DESC-L10',
  'ASC-L10',
  'DESC-name_for_sorting',
  'ASC-name_for_sorting',
  'DESC-next_classic_fixture_projected_score',
  'ASC-next_classic_fixture_projected_score',
  'DESC-next_daily_fixture_projected_score',
  'ASC-next_daily_fixture_projected_score',
  'DESC-difference_last_ten_and_daily_projection',
  'ASC-difference_last_ten_and_daily_projection',
  'DESC-difference_last_ten_and_classic_projection',
  'ASC-difference_last_ten_and_classic_projection',
  'ASC-points',
  'DESC-points',
  'ASC-assists',
  'DESC-assists',
  'ASC-rebounds',
  'DESC-rebounds',
  'ASC-blocks',
  'DESC-blocks',
  'ASC-double_double',
  'DESC-double_double',
  'ASC-average_mins_played',
  'DESC-average_mins_played',
  'ASC-steals',
  'DESC-steals',
  'ASC-three_points_made',
  'DESC-three_points_made',
  'ASC-triple_double',
  'DESC-triple_double',
  'ASC-turnovers',
  'DESC-turnovers',
];
